module.exports = __webpack_public_path__ + "media/night/302-05655fd0.svg";